import Header from "../components/common/header";
import MainComponent from "../components/LangingPage/MainComponent";

function HomePage() {
  return (
    <div>
      <Header />
      <MainComponent  />
    </div>
  );
}

export default HomePage;